import * as React from "react";

function SvgLicensing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={16.941} cy={11.294} fill="#fff" r={4.235} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.118 15.35V24l2.823-2.824L19.765 24v-8.65c-.8.558-1.774.885-2.824.885a4.918 4.918 0 01-2.823-.885z"
        fill="#fff"
      />
      <path
        fill="#fff"
        d="M3.529 3.529H20.47v1.412H3.529zM3.529 6.353h7.765v1.412H3.529zM3.529 9.176h7.765v1.412H3.529zM3.529 12h7.765v1.412H3.529z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.824A2.824 2.824 0 012.824 0h18.352A2.824 2.824 0 0124 2.824v12.705a2.823 2.823 0 01-2.823 2.824h-.706V16.94h.706c.78 0 1.411-.632 1.411-1.412V2.824c0-.78-.632-1.412-1.412-1.412H2.825c-.78 0-1.412.632-1.412 1.412v12.705c0 .78.632 1.412 1.412 1.412h10.588v1.412H2.824A2.824 2.824 0 010 15.529V2.824z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLicensing;
